import TableOfContentsHeading from './table_of_contents_heading.vue?vue3';
export default {
    name: 'TableOfContents',
    components: {
        TableOfContentsHeading
    },
    props: {
        headings: {
            type: Array,
            required: true
        }
    }
};
